module.exports = __webpack_public_path__ + "static/media/issue2.207cbe89.webp";